import React from 'react';
import { IconAlertTriangle, IconCircleCheck, IconInfoCircle, IconAlertCircle } from '@tabler/icons-react';
import FigureSub from '@/components/ui/list/figure/Figure.Sub';
import ItemRow from '@/components/ui/list/Item.Row';
import type { TypeNotification, TypeNotificationSeverity } from '@/types/notification/types.notification';
import { formatDateTime, formatRelative } from '@/utils/format.time';

const SEVERITY = {
    danger: { icon: IconAlertCircle, color: 'var(--bd-status-danger)', soft: 'var(--bd-status-danger-soft)' },
    warning: { icon: IconAlertTriangle, color: 'var(--bd-status-warning)', soft: 'var(--bd-status-warning-soft)' },
    info: { icon: IconInfoCircle, color: 'var(--bd-status-info)', soft: 'var(--bd-status-info-soft)' },
    success: { icon: IconCircleCheck, color: 'var(--bd-status-success)', soft: 'var(--bd-status-success-soft)' },
} satisfies Record<TypeNotificationSeverity, { icon: React.ElementType; color: string; soft: string }>;

const UNREAD_DOT: React.CSSProperties = { width: '0.4375rem', height: '0.4375rem', borderRadius: '50%', backgroundColor: 'var(--bd-brand-text)' };

const ShellNotificationsItem: React.FC<{ item: TypeNotification }> = ({ item }) => {
    const severity = SEVERITY[item.severity];
    const Icon = severity.icon;

    return (
        <ItemRow
            leading={<span className="bd-li-tile" style={{ backgroundColor: severity.soft, color: severity.color }}><Icon size={16} stroke={1.8} /></span>}
            title={<span style={{ fontWeight: item.read ? 500 : 650 }}>{item.title}</span>}
            titleAttr={item.title}
            description={<span title={item.body}>{item.body}</span>}
            meta={<FigureSub><span title={formatDateTime(item.at)}>{formatRelative(item.at)}</span></FigureSub>}
            trailing={item.read ? undefined : <span aria-hidden style={UNREAD_DOT} />}
            stack="none"
        />
    );
};

export default React.memo(ShellNotificationsItem);
